import * as yup from "yup";

export default yup.object().shape({
  coverage: yup
    .number()
    .required("É necessário informar a cobertura.")
    .min(30, "É necessário que a cobertura seja ao menos 30.")
});
